import { render, staticRenderFns } from "./Proprietaire.vue?vue&type=template&id=7ed19ace&scoped=true&"
import script from "./Proprietaire.vue?vue&type=script&lang=js&"
export * from "./Proprietaire.vue?vue&type=script&lang=js&"
import style0 from "./Proprietaire.vue?vue&type=style&index=0&id=7ed19ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed19ace",
  null
  
)

export default component.exports